(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conversion-card"] && !Shopify.designMode) return;
  try {
    
  const moveConversionCard = () => {
    const conversionCard = document.querySelector('.conversion-card')

    if (!conversionCard) return

    const targets = document.querySelectorAll('.conversion-card__placeholder')

    if (!targets.length) return

    targets.forEach(target => {
      const clone = conversionCard.cloneNode(true)
      target.insertAdjacentElement('afterbegin', clone)
      clone.classList.add('conversion-card--inline')
    })

    conversionCard.remove()
  }

  if (document.readyState === 'complete') {
    moveConversionCard()
  } else {
    document.addEventListener('DOMContentLoaded', moveConversionCard)
  }

  } catch(e) { console.error(e); }
})();
})();
